module.exports = __webpack_public_path__ + "plane.png";


//////////////////
// WEBPACK FOOTER
// ./app/theme/img/plane.png
// module id = 642
// module chunks = 0